export default "__VITE_ASSET__BN7AdjaR__"